import PropTypes from 'prop-types';
import { useState, useEffect, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppSelect from './select';

const styles = {
  input: {
    height: '30px',
    width: '100%',
    padding: '0 5px'
  },
  editWrap: {
    position: 'absolute',
    top: '16px',
    right: '16px'
  }
};
/**
 * 单头自定义字段组件
 *
 */
function HeadCustField(props) {
  const {
    classes,
    fieldSetting,
    detail,
    setDetail,
    isEdit,
    isPurchase,
    showSave,
    onSave
  } = props;

  const [isInEdit, setIsInEdit] = useState(false);

  //文本|数字字段改变
  function handleChange(e) {
    let obj = {};
    obj[e.target.name] = e.target.value;
    setDetail(Object.assign({}, detail, obj));
  }

  //下拉选单改变
  function handleSelectChange(e, fieldCode) {
    setDetail(Object.assign({}, detail, { [fieldCode]: e.id }));
  }

  //单独保存
  function save() {
    setIsInEdit(false);
    if (typeof onSave === 'function') {
      onSave();
    }
  }

  // 初始化默认预设值
  // if (fieldSetting?.billType && isEdit) {
  //   fieldSetting.bodyCustList.forEach(field => {
  //     if (
  //       field.fieldValueType === 2 &&
  //       !field.presetValueList
  //         ?.map(row => row.id)
  //         .includes(detail[field.fieldCode])
  //     ) {
  //       // 预设值列表不包含当前字段值时，如果有默认值，设置为默认值。
  //       field.presetValueList.forEach(row => {
  //         if (row.isDefault === 1) {
  //           detail[field.fieldCode] = row.id;
  //         }
  //       });
  //     }
  //   });
  // }

  let headCustList = fieldSetting.headCustList || [];
  if (headCustList.length === 0) {
    return '';
  }

  return (
    <div className="order-detail-block">
      <div className="order-detail-title">
        <label>自定义字段</label>
      </div>
      <ul>
        {headCustList.map((field, index) => {
          let edit =
            (isEdit || isInEdit) &&
            (isPurchase
              ? field.editFlag === 1
              : field.needVendorInputFlag === 1);

          return (
            <li key={index}>
              <label className="order-detail-label">{field.transName}</label>
              {edit ? (
                <div className="order-detail-value">
                  {/* 数字 */}
                  {field.fieldValueType === 0 && (
                    <input
                      type="number"
                      className={classes.input}
                      name={field.fieldCode}
                      value={detail[field.fieldCode] || ''}
                      onChange={handleChange}
                    />
                  )}
                  {/* 文本 */}
                  {field.fieldValueType === 1 && (
                    <input
                      type="text"
                      className={classes.input}
                      name={field.fieldCode}
                      value={detail[field.fieldCode] || ''}
                      onChange={handleChange}
                    />
                  )}
                  {/* 预设值 */}
                  {field.fieldValueType === 2 && (
                    <AppSelect
                      value={detail[field.fieldCode]}
                      options={field.presetValueList}
                      change={e => handleSelectChange(e, field.fieldCode)}
                    ></AppSelect>
                  )}
                  {/* 日期 与pc端不同，返回的不是时间戳，而是 YYYY-MM-DD */}
                  {field.fieldValueType === 3 && (
                    <input
                      type="date"
                      className={classes.input}
                      name={field.fieldCode}
                      value={detail[field.fieldCode] || ''}
                      onChange={handleChange}
                    />
                  )}
                </div>
              ) : (
                <div className="order-detail-value">
                  {detail[field.fieldCode]}
                </div>
              )}
            </li>
          );
        })}
      </ul>

      {showSave && (
        <span>
          <div className={classes.editWrap}>
            {!isInEdit && (
              <span
                className="u-handle u-edit"
                onClick={() => {
                  setIsInEdit(true);
                }}
              >
                <i className="icon-edit"></i>
              </span>
            )}
          </div>
          {isInEdit && (
            <div className="m-flex-box wrap">
              <span
                className="m-flex-item u-btn u-btn_primary"
                onClick={() => {
                  save();
                }}
              >
                保存
              </span>
              <span
                className="m-flex-item u-btn u-btn_line"
                onClick={() => {
                  setIsInEdit(false);
                }}
              >
                取消
              </span>
            </div>
          )}
        </span>
      )}
    </div>
  );
}

HeadCustField.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(HeadCustField);
